export default __webpack_public_path__ + "static/media/left-front-ring.65cfd271.png";